<template>
  <div class="game-wrap">
    <back-button :tag="false" />
    <div :class="['game-players', gameStatus < 3 ? 'search-status' : '']">
      <div class="player myself">
        <van-image
          class="avator"
          v-if="user"
          :src="user.avatar || ''"
          alt="头像"
          round
          fit="cover"
        />
        <div v-if="user" class="player-name">{{ user.nickname }}</div>
      </div>
      <div></div>
      <div>
        <img class="versus-logo" src="@/assets/img/versus-img.png" />
        <div v-if="starting == 1" class="versus-tips">
          正在为你匹配对手{{ seconds }}秒
        </div>
        <div v-if="starting == 2" class="versus-score">
          <div class="my-score">答对{{ score1 ? score1.right_num : 0 }}题</div>
          <div class="opponent">答对{{ score2 ? score2.right_num : 0 }}题</div>
        </div>
      </div>
      <div class="player opponent">
        <van-image
          :class="['avator', starting === 1 ? 'matching' : '']"
          :src="
            starting == 2 && player2
              ? player2.avatar || require('@/assets/unlogin-avatar.png')
              : require('@/assets/unlogin-avatar.png')
          "
          alt="头像"
          round
          fit="cover"
        />
        <div v-if="player2" class="player-name">{{ player2.nickname }}</div>
      </div>
    </div>
    <div class="question-wrap2">
      <transition
        enter-active-class="animate__animated animate__rotateInDownRight"
        leave-active-class="animate__animated animate__rotateOutUpLeft"
        @before-leave="beforeLeave"
      >
        <question
          v-if="question"
          :key="question.id"
          :id="question.id"
          :question="question.question"
          :answers="question.answer"
          :num="question.q_num"
          :sum="question.q_sum"
          :qids="qids"
          @end="next"
        />
      </transition>
    </div>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
import Question from "./Question";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    BackButton,
    Question,
  },
  data() {
    return {
      starting: 0,
      seconds: 0,
      timer: 0,
      qids: [],
    };
  },
  watch: {
    // 监听游戏结束状态，自动跳转结果页
    gameStatus: {
      handler(newVal) {
        if (newVal === 5) {
          setTimeout(() => {
            // 跳转前判断路径，避免重复跳转报错
            if (this.$route.path !== "/versus/result") {
              this.$router.replace("/versus/result");
            }
          }, 1000);
        } else if (newVal === 3) {
          this.starting = 2;
          clearInterval(this.timer);
        }
      },
      immediate: false,
    },
    score2: {
      handler(newVal) {
        if (newVal && !this.qids.includes(newVal.qid)) {
          this.qids.push(newVal.qid);
        }
      },
      deep: true,
      immediate: false,
    },
  },

  computed: {
    ...mapState("versus", [
      "gameStatus",
      "player1",
      "player2",
      "socket",
      "score1",
      "score2",
    ]),
    user() {
      return this.$store.state.user.user;
    },
    question() {
      return this.$store.state.versus.currentQuestion;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.closeSocket();
  },
  mounted() {
    if (this.user.token) {
      this.startGame();
    } else {
      this.$notify({
        type: "danger",
        message: "请完善用户信息",
        duration: 2000,
      });
    }
  },
  methods: {
    ...mapActions("versus", [
      "initSocket",
      "sendMessage",
      "closeSocket",
      "reset",
    ]),
    beforeLeave(el) {
      el.classList.add("before-leave");
    },
    cleanup() {
      this.clearTimer();
      this.reset();
    },
    // 清理定时器
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    resetGame() {
      this.starting = 0;
      clearInterval(this.timer);
      this.seconds = 0;
    },
    startGame() {
      if (this.starting >= 1) {
        return;
      }
      this.starting = 1;
      this.seconds = 0;
      this.timer = setInterval(() => {
        if (this.seconds >= 40) {
          this.$toast.fail("匹配超时，为您重新匹配");
          this.restartGame();
        }
        this.seconds++;
      }, 1000);
      // 第二步：开始游戏，加入房间
      if (!this.socket || this.socket?.readyState !== 1) {
        // this.$toast.fail("连接已中断，正在重新连接……");
        this.restartGame();
        return;
      }
      this.sendMessage({
        type: "join", // 类型，join:加入房间，answer：回答
        token: this.$store.state.user.user.token,
        client_id: this.clientId,
      });
    },
    restartGame() {
      this.reset();
      // 第一步:初始化socket，连接到服务器
      this.initSocket();
      this.resetGame();
      let count = 10;
      const timer = setInterval(() => {
        if (this.socket?.readyState === 1) {
          clearInterval(timer);
          this.startGame();
        } else {
          if (count <= 0) {
            clearInterval(timer);
            this.reset();
          }
          count--;
        }
      }, 100);
    },
    next() {
      console.log("111");
    },
  },
  created() {
    // 游戏状态异常，直接返回对战首页
    //   if (this.gameStatus < 3) {
    //     if (this.$route.path !== "/versus/index") {
    //       this.$router.replace("/versus/index");
    //     }
    //   }
  },
  // beforeRouteLeave(to, from, next) {
  //   if (to.path !== "/versus/game" || to.path !== "/versus/result") {
  //     this.reset();
  //   }
  //   next();
  // },
};
</script>
<style lang="scss" scoped>
.game-wrap {
  @include index-bg;
  .game-players {
    display: flex;
    align-items: center;
    margin: 30px 28px;
    .player {
      z-index: 10;
      .avator {
        width: 62px;
        height: 62px;
      }
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .matching {
        animation: rotate 1s linear infinite;
      }
      .player-name {
        max-width: 62px;
        font-size: 15px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        @include textoverflow(1);
      }
    }
    .myself {
      margin-right: -24px;
    }
    .opponent {
      margin-left: -24px;
    }
    .versus-tips {
      font-size: 14px;
      color: #fff;
      text-align: center;
    }
    .versus-logo {
      width: 244px;
      height: 30px;
    }
    .versus-score {
      display: flex;
      justify-content: space-between;
      padding: 0 28px;
      font-size: 12px;
      color: rgb(75, 241, 75);
      .opponent {
        color: rgb(241, 84, 84);
      }
    }
  }
  .search-status {
    margin-top: 200px;
  }
  .question-wrap2 {
    padding: 30px 20px;
  }
  .before-leave {
    position: absolute;
    right: 20px;
    left: 20px;
  }
}
</style>
